<template>
    <div class="vehicle-image">
        <a v-if="linkEnabled" :href="buildUrl('vehicles/' + instance.id + '/overview')">
            <vehicle-image-inner :instance="instance"></vehicle-image-inner>
        </a>
        <vehicle-image-inner v-else :instance="instance"></vehicle-image-inner>
    </div>
</template>

<style>
    .vehicle-image figure { width: 100%; background-color: #fafafa; margin: 0; }
    .vehicle-image figure.no-image { height: 100px; }
    .vehicle-image figure img { max-width: 100%; height: auto;  }
</style>

<script>
    import {buildUrl} from "../../utils";
    import VehicleImageInner from "./VehicleImageInner.vue";

    export default {
        components: {VehicleImageInner},
        methods: {buildUrl},
        props: {
            instance: {
                required: true
            },
            linkEnabled: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>